import React from 'react';
import { Form } from 'react-bootstrap';

interface CheckboxInputProps {
    id: string;
    name: string;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    label: string;
    description?: string;
    required?: boolean;
}

export const CheckboxInput: React.FC<CheckboxInputProps> = ({
    id,
    name,
    checked,
    onChange,
    label,
    description,
    required = false
}) => {
    return (
        <Form.Check className="mb-2">
            <Form.Check.Input
                type="checkbox"
                id={id}
                name={name}
                checked={checked}
                onChange={onChange}
                required={required}
            />
            <Form.Check.Label htmlFor={id}>
                {label}
                {description && (
                    <span className="d-block text-muted small">{description}</span>
                )}
            </Form.Check.Label>
        </Form.Check>
    );
};
